import Tr from 'translations/Translations';

export const VALUES = {
    ALL: '',
    PREPARING: 'PREPARING',
    ACTIVE: 'ACTIVE',
    FINISHED: 'FINISHED'
}

export const LABELS = {
    [VALUES.ALL]: Tr('audit_task_status_all'),
    [VALUES.PREPARING]: Tr('audit_task_status_preparing'),
    [VALUES.ACTIVE]: Tr('audit_task_status_active'),
    [VALUES.FINISHED]: Tr('audit_task_status_finished')
}

const createItem = (e) => ({
    label: LABELS[e],
    value: e,
})

export default Object.values(VALUES).map(x => createItem(x))
